import { type ComponentType } from "react";
import ScrollToTop from "./ScrollToTop";
import Navbar from "./Navbar";
import Footer from "./Footer";

export function withLayout(Component: ComponentType) {
  return function LayoutWrapper() {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="pt-[72px]">
          <Component />
        </main>
        <Footer />
      </>
    );
  };
}